import { IDestroyOptions, Sprite, Texture } from "pixi.js";
import { ICanvasScaler } from "../../../canvas/ICanvasScaler";
import { Scales } from "../../../canvas/CanvasScaler";

export class FullScreenBackground extends Sprite {
    public constructor(
        private readonly canvasScaler: ICanvasScaler,
        texture: Texture
    ) {
        super(texture);
        this.canvasScaler.onResize.add(this.layout, this);
        this.layout(this.canvasScaler.getSize());
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.canvasScaler.onResize.remove(this.layout, this);
        super.destroy(options);
    }

    private layout(scales: Scales): void {
        this.scale.set(1);
        this.scale.set((this.canvasScaler.browserHeight * (scales.height / this.canvasScaler.browserHeight)) / this.height);
        this.position.x = (this.canvasScaler.referenceWidth - this.width) * 0.5;
    }
}